import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import routes from './index'
import { Message } from 'element-ui'
import store from '@/store/index'
import { DynamicRoutes, CARD_MENU } from '@/router/index'
import { GetRequest, setToken, removeToken, getToken } from '@/utils/auth.js'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
const router = new Router({ routes })
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (to.path === '/login') {
    removeToken()
    sessionStorage.removeItem('username')
    next()
  }
  if (GetRequest('token'))setToken(GetRequest('token'))
  const token = getToken()
  if (!token && to.path !== '/login') {
    if (to.path === '/bind') {
      document.title = '桩管家订阅绑定'
      next()
    } else {
      next({ path: '/login' })
    }
  } else {
    // 面包屑数据
    store.commit('SET_BREADCRUMBLIST', to.matched)
    if (store.state.login.menuList.length === 0 && to.path !== '/login') {
      store.dispatch('getmenusAsync').then(res => {
        if (res.length === 0 || res === undefined) {
          Message({
            message: '对不起您菜单权限不足，请联系管理员',
            type: 'error',
            duration: 3 * 1000
          })
          next({ path: '/login' })
        }
        // 增加动态路由
        if (res[0].url) {
          DynamicRoutes[3].redirect = {}
          DynamicRoutes[3].redirect.name = res.filter(item => {
            if (!item.hidden) return item
          })[0].url
        }
        const menuList = [] // 动态添加的菜单
        // /sys/dict/dictlist
        res.forEach((item, index) => {
          if (item.hidden) return
          var modelobj = {
            path: `/${item.url}`,
            name: item.url,
            meta: { title: item.name, icon: '', hidden: false },
            component: () => import('@/views/home.vue'),
            // redirect: {name: item.children ? item.children[0].url : ''},
            children: []
          }
          if (item.children) {
            modelobj.redirect = {}
            modelobj.redirect.name = item.children[0].url
          }
          if (item.children) {
            item.children.forEach((item1, index1) => {
              if (item1.hidden) return
              var menuobj = {
                path: item1.url,
                name: item1.url,
                meta: { title: item1.name, icon: '', hidden: false, url: `@/views/${item.url}/${item1.url}/index.vue` },
                // component: () => import(`@/views/${item.url}/${item1.url}/index.vue`),
                component: () => import('@/views/index.vue'),
                // redirect: {name: item1.children ? item1.children[0].url : ''},
                children: []
              }
              if (item1.children) {
                menuobj.redirect = {}
                menuobj.redirect.name = item1.children[0].url
              }
              modelobj.children.push(menuobj)
              if (item1.children) {
                item1.children.forEach((item2, index2) => {
                  if (item2.hidden) return
                  var obj = {
                    path: item2.url,
                    name: item2.url.split('/')[0],
                    meta: { title: item2.name, icon: '', hidden: false, url: `@/views/${item.url}/${item1.url}/${item2.url}.vue` },
                    component: () => import(`@/views/${item.url}/${item1.url}/${item2.extra}.vue`)
                  }
                  menuobj.children.push(obj)
                })
              }
            })
          }
          DynamicRoutes.push(modelobj)
          menuList.push(modelobj)
        })
        // console.log(menuList)
        // 动态添加菜单
        store.commit('SET_MENULIST', menuList)
        // 动态添加可访问路由表
        router.addRoutes(DynamicRoutes)
        next({ ...to, replace: true })
      })
    } else {
      next()
    }

    // 路由中添加
    store.commit('SET_TABINDEX_PREMISSION', [...this.$store.state.login.breadcrumblist, to])
    next()
  }
})

router.afterEach((to, from) => {
  if (to.name !== 'login' && to.meta && to.meta.title) {
    // 登录、监控页面不加入tab 标签
    const { title, icon } = to.meta
    store.commit('addTab', { title, icon, path: to.path, query: to.query, name: to.name })
  }
  NProgress.done()
})
router.onError(() => {
  NProgress.done()
})
export default router



// WEBPACK FOOTER //
// ./src/router/premission.js